// import React from 'react';
// import './Career.css';

// const Career = () => {
//   return (
//     <div className="career-container">
//       <h1 className="career-title">Join the LogicBunny Team</h1>
//       <p className="career-intro">
//         At LogicBunny, we're always on the lookout for talented and passionate individuals who are ready to take on new challenges and contribute to innovative solutions.
//       </p>
//       <h2 className="career-opportunities-title">Current Career Opportunities</h2>
//       <ul className="career-opportunities-list">
//         <li className="career-opportunity">
//           <h3>Software Engineer</h3>
//           <p>
//             We're looking for skilled software engineers who are proficient in modern programming languages and passionate about building high-quality software.
//           </p>
//         </li>
//         <li className="career-opportunity">
//           <h3>UI/UX Designer</h3>
//           <p>
//             Join our design team to create intuitive and engaging user interfaces that delight our customers.
//           </p>
//         </li>
//         <li className="career-opportunity">
//           <h3>Product Manager</h3>
//           <p>
//             Lead our product development efforts and work closely with cross-functional teams to bring new ideas to life.
//           </p>
//         </li>
//         <li className="career-opportunity">
//           <h3>DevOps Engineer</h3>
//           <p>
//             Help us streamline our operations and ensure our systems are secure, scalable, and efficient.
//           </p>
//         </li>
//       </ul>
//       <p className="career-apply">
//         If you're excited about what we do and think you'd be a great fit, we'd love to hear from you! Send your resume to <a href="mailto:careers@logicbunny.com">careers@logicbunny.com</a>.
//       </p>
//     </div>
//   );
// };

// export default Career;


import React from 'react';
import './Career.css';

const Career = () => {
  return (
    <div className="career-container">
      {/* Header Section */}
      <header className="career-header">
        <h1 className="career-title">🚀 Join the LogicBunny Team</h1>
        <p className="career-intro">
          At LogicBunny, we're passionate about technology and innovation. We’re looking for talented individuals 
          who want to make an impact in the tech world.
        </p>
      </header>

      {/* Why Join Us Section */}
      <section className="career-why">
        <h2>🌟 Why Work With Us?</h2>
        <ul>
          <li>💡 Work on cutting-edge technology and innovative projects.</li>
          <li>🤝 Collaborative and inclusive team environment.</li>
          <li>📈 Career growth and learning opportunities.</li>
          <li>🏡 Flexible work environment with remote options.</li>
          <li>💰 Competitive salary and benefits package.</li>
        </ul>
      </section>

      {/* Career Opportunities Section */}
      <section className="career-opportunities">
        <h2>💼 Current Career Opportunities</h2>
        <ul className="career-opportunities-list">
          <li className="career-opportunity">
            <h3>Software Engineer</h3>
            <p>
              We’re looking for skilled software engineers proficient in JavaScript, Node.js, React, and cloud technologies.
              If you love solving problems and writing clean code, apply now!
            </p>
          </li>
          <li className="career-opportunity">
            <h3>UI/UX Designer</h3>
            <p>
              Passionate about creating intuitive and visually appealing user experiences? Join our design team
              to craft user-friendly interfaces and engaging digital experiences.
            </p>
          </li>
          <li className="career-opportunity">
            <h3>Product Manager</h3>
            <p>
              Lead our product development efforts, work with cross-functional teams, and help shape the future of 
              our innovative software solutions.
            </p>
          </li>
          <li className="career-opportunity">
            <h3>DevOps Engineer</h3>
            <p>
              Ensure our systems are secure, scalable, and efficient by optimizing our development pipelines and 
              cloud infrastructure.
            </p>
          </li>
        </ul>
      </section>

      {/* Application CTA */}
      <section className="career-apply-section">
        <h2>📩 How to Apply</h2>
        <p>
          If you're excited about joining LogicBunny, send your resume and cover letter to 
          <a href="mailto:careers@logicbunny.com" className="career-email"> careers@logicbunny.com</a>.  
        </p>
        <p>We look forward to hearing from you! 🎉</p>
      </section>
    </div>
  );
};

export default Career;
